import type { Ref } from 'vue';
import { computed } from 'vue';

import type { ITranslationsKeyMap } from '@modules/i18n/types';

export function getTranslationKeys(): Ref<ITranslationsKeyMap> {
  return computed(() => ({
    admin: {
      settings: {
        general_settings: {
          welcome_page_redirects: {
            header: 'WELCOME_PAGE_REDIRECTS_HEADER',
            enable_redirect: 'WELCOME_PAGE_REDIRECTS_ENABLE_REDIRECT',
            welcome_page_uri: 'WELCOME_PAGE_REDIRECTS_URI',
            save_button: 'WELCOME_PAGE_REDIRECTS_SAVE_BUTTON',
          },
        },
      },
    },
  }));
}
